export default __webpack_public_path__ + "static/media/chevron_black.e4905f1e.svg";